import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

export default new VueRouter({ /*配置路由跳转页面*/
  // mode: 'history hash',
  mode:'hash',routes:[
    {
      path:'/',name:'login',component:() => import('../pages/login.vue')
    },
    {
      path:'/ctrDbShow',name:'ctrDbShow',component:() => import('../components/mem/ctrDbShow.vue')
    },
    {
      path:'/home',component:() => import('../pages/home.vue'),children:[
        {path:'',name:'',component:() => import('../pages/ctr/glDevList.vue')},
        {path:'data',name:'data',component:() => import('../pages/count/dshboard.vue')},
        {path:'manageArea',name:'manageArea',component:() => import('../pages/gls/glArea.vue')},
        {path:'manageAreaGrp',name:'manageAreaGrp',component:() => import('../pages/gls/glAreaGrp.vue')},
        {path:'manageDev',name:'manageDev',component:() => import('../pages/ctr/glDev.vue')},
        {path:'ctrDb',name:'ctrDb',component:() => import('../components/mem/ctrDb.vue')},
        {path:'manageDevErr',name:'manageDevErr',component:() => import('../pages/ctr/glDevErr.vue')},
        {path:'airCtr',name:'airCtr',component:() => import('../pages/ctr/airCtr.vue')},
        {path:'devGroup',name:'devGroup',component:() => import('../pages/ctr/devGroup.vue')},
        {path:'manageDevList',name:'manageDevList',component:() => import('../pages/ctr/glDevList.vue')},
        {
          path:'manageDevListSon',name:'manageDevListSon',component:() => import('../pages/ctr/glDevListSon.vue')
        },
        {path:'manageDevSonLd',name:'manageDevSonLd',component:() => import('../pages/ctr/glDevSonLd.vue')},
        {path:'manageDevSonAir',name:'manageDevSonAir',component:() => import('../pages/ctr/glDevSonAir.vue')},
        {
          path:'manageDevSonTemp',name:'manageDevSonTemp',component:() => import('../pages/ctr/glDevSonTemp.vue')
        },
        {path:'manageDevSonSon',name:'manageDevSonSon',component:() => import('../pages/ctr/glDevSonSon.vue')},
        {path:'countCompany',name:'countCompany',component:() => import('../pages/count/countCompany.vue')},
        {path:'countCompanyTab',name:'countCompanyTab',component:() => import('../pages/count/countCompanyTab.vue')},
        {path:'enterprise',name:'enterprise',component:() => import('../pages/enterprise/glEbteroruse.vue')},
        {path:'enterpriseDepart',name:'enterpriseDepart',component:() => import('../pages/enterprise/enterpriseDepart.vue')},
        {path:'enterpriseUser',name:'enterpriseUser',component:() => import('../pages/enterprise/enterpriseUser.vue')},
        {path:'countFactor',name:'countFactor',component:() => import('../pages/count/countFactor.vue')},
        {path:'countPrice',name:'countPrice',component:() => import('../pages/count/countPrice.vue')},
        {path:'holidayPrice',name:'holidayPrice',component:() => import('../pages/count/holidayPrice.vue')},
        {path:'countTab',name:'countTab',component:() => import('../pages/count/countTab.vue')},
        {path:'countMeter',name:'countMeter',component:() => import('../pages/count/countDb.vue')},
        {path:'countMeterStatis',name:'countMeterStatis',component:() => import('../pages/count/countMeterStatis.vue')},
        {path:'dataEnergy',name:'dataEnergy',component:() => import('../components/dataEnergy.vue')},
        {path:'manageUser',name:'manageUser',component:() => import('../pages/gls/glUser.vue')},
        {path:'manageUserSon',name:'manageUserSon',component:() => import('../pages/gls/glUserSon.vue')},
        {path:'manageWx',name:'manageWx',component:() => import('../pages/gls/glWx.vue')},
        {path:'scene',name:'scene',component:() => import('../pages/scene/scene.vue')},
        {path:'sceneSon',name:'sceneSon',component:() => import('../pages/scene/sceneSon.vue')},
        {path:'timing',name:'timing',component:() => import('../pages/scene/timing.vue')},
        {path:'timingSon',name:'timingSon',component:() => import('../pages/scene/timingSon.vue')},
        {path:'sceneTlink',name:'sceneTlink',component:() => import('../pages/scene/sceneTlink.vue')},
        {path:'sceneTlinkSon',name:'sceneTlinkSon',component:() => import('../pages/scene/sceneTlinkSon.vue')},
        {path:'tlinkTjcf',name:'tlinkTjcf',component:() => import('../pages/scene/tlinkTjcf.vue')},
        {path:'tlinkTjcfSon',name:'tlinkTjcfSon',component:() => import('../pages/scene/tlinkTjcfSon.vue')},
        {path:'tlinkTjys',name:'tlinkTjys',component:() => import('../pages/scene/tlinkTjys.vue')},
        {path:'tlinkTjysSon',name:'tlinkTjysSon',component:() => import('../pages/scene/tlinkTjysSon.vue')},
        {path:'tlinkTjtime',name:'tlinkTjtime',component:() => import('../pages/scene/tlinkTjtime.vue')},
        {
          path:'tlinkTjtimeSon',name:'tlinkTjtimeSon',component:() => import('../pages/scene/tlinkTjtimeSon.vue')
        },
        {
          path:'log',component:() => import('../pages/logs/log.vue'),children:[
            {path:'',name:'',component:() => import('../pages/logs/logLogin.vue')},
            {path:'logLogin',name:'logLogin',component:() => import('../pages/logs/logLogin.vue')},
            {path:'logUser',name:'logUser',component:() => import('../pages/logs/logUser.vue')},
            {path:'logDev',name:'logDev',component:() => import('../pages/logs/logDev.vue')},
            {path:'logDevState',name:'logDevState',component:() => import('../pages/logs/logDevState.vue')},
            {path:'logTiming',name:'logTiming',component:() => import('../pages/logs/logTiming.vue')},
            {path:'logTimingExe',name:'logTimingExe',component:() => import('../pages/logs/logTimingExe.vue')},
            {path:'logSceneMgr',name:'logSceneMgr',component:() => import('../pages/logs/logSceneMgr.vue')},
            {path:'logScene',name:'logScene',component:() => import('../pages/logs/logScene.vue')},
            {path:'logAuto',name:'logAuto',component:() => import('../pages/logs/logAuto.vue')},
            {path:'logAutoExe',name:'logAutoExe',component:() => import('../pages/logs/logAutoExe.vue')}
          ]
        }
      ]
    }
  ]
});

/*隐藏Router报错警示*/
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this,location).catch(err => err);
};



// WEBPACK FOOTER //
// ./src/router/index.js